// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__rId1Z","card":"styles_card__TTxlw","imgContainer":"styles_imgContainer__GtJul","textCard":"styles_textCard__KT_FG"};